import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useI18n } from "@/lib/i18n";

/**
 * /demo — stable entry point for the public demonstration. Resolves the first
 * active TRAINING game and forwards to its full-page demo (auto-plays & loops,
 * with a VOLVER back button). Using a route instead of a hard-coded game id in
 * the DEMO badge means the link never breaks when games change.
 */
export default function DemoRedirect() {
  const nav = useNavigate();
  const { lang } = useI18n();
  useEffect(() => {
    let alive = true;
    api
      .get("/games", { params: { status: "training", active_only: true } })
      .then((r) => {
        if (!alive) return;
        const list = r?.data || [];
        if (list.length) {
          nav(`/jogar/${list[0].id}?mode=training&demo=1&lang=${encodeURIComponent(lang || "pt")}`, { replace: true });
        } else {
          nav("/", { replace: true });
        }
      })
      .catch(() => { if (alive) nav("/", { replace: true }); });
    return () => { alive = false; };
  }, [nav, lang]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#04081F",
        color: "#FFFFFF",
        fontFamily: "Fredoka, sans-serif",
        fontWeight: 700,
        letterSpacing: "0.04em",
      }}
      data-testid="demo-redirect"
    >
      {lang === "en" ? "Opening demo…" : lang === "es" ? "Abriendo demostración…" : "A abrir demonstração…"}
    </div>
  );
}
